const DataStatusPembayaran = [
    {
        id: "1",
        jenisPembayaran: "Pendaftaran",
        bayar: "Rp. 20.000",
        status: "Lunas"
    },
    {
        id: "2",
        jenisPembayaran: "Diklat",
        bayar: "Rp. 0",
        status: "Belum Lunas"
    },
    {
        id: "3",
        jenisPembayaran: "Pengukuhan",
        bayar: "Rp. 0",
        status: "Belum Lunas"
    },
]

export default DataStatusPembayaran